/*
 Created by CHT 2019/10/14 16:54
 */

import {
  FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__MULTILINE,
  FORM_ITEM__NUMBER,
  FORM_ITEM__CURRENCY,
  FORM_ITEM__SERIAL_NUMBER,
  FORM_ITEM__DESCRIPTION,
  FORM_ITEM__DIVIDINGLINE,
  FORM_ITEM__SINGLE_CHOOSE,
  FORM_ITEM__CHECKBOX,
  FORM_ITEM__DROPDOWN,
  FORM_ITEM__RTF,
  FORM_ITEM__DATE,
  FORM_ITEM__DATE_RANGE,
  FORM_ITEM__IMAGE,
  FORM_ITEM__ATTACHMENT,
  FORM_ITEM__GRADE,
  FORM_ITEM__IMAGE_CHOOSE,
  FORM_ITEM__SLIDING_BLOCK,
  FORM_ITEM__YES_NO,
  FORM_ITEM__ADDRESS,
  FORM_ITEM__MEMBER,
  FORM_ITEM__DEPARTMENT,
  FORM_ITEM__TABLE,
  FORM_ITEM__SUMMARY,
  FORM_ITEM__EXTERNAL_DATA_SOURCE,
  FORM_ITEM__PHONE,
  FORM_ITEM__LOCATION,
  FORM_ITEM__OUT_REQUEST,
  FORM_ITEM__SIGNATURE,
  FORM_ITEM__BUTTON,
  FORM_ITEM__RELATE_RECORD,
  FORM_ITEM__REALTIME_DATA,
  FORM_ITEM__CURRENT_VIEW_USER,
  FORM_ITEM__CASCADE,
  FORM_ITEM__IFRAME,
  FORM_ITEM__VIDEO,
  FORM_ITEM__QRCODE,
  FORM_ITEM__LARK_APPROVAL,
  FORM_ITEM__THIRD_DATA_TABLE, FORM_ITEM__THIRD_MAP,
  FORM_ITEM__LINK_QUERY
} from '../types'

import SingleLine from './SingleLine'
import Multiline from './Multiline'
import Digital from './Digital'
import Currency from './Currency'
import SerialNumber from './SerialNumber'
import Description from './Description'
import DividingLine from './DividingLine'
import SingleChoose from './SingleChoose'
import Checkbox from './Checkbox'
import Dropdown from './Dropdown'
import Rtf from './Rtf'
import DateInput from './DateInput'
import DateRange from './DateRange'
import ImageAttachment from './ImageAttachment'
import Attachment from './Attachment'
import Grade from './Grade'
import ImageChoose from './ImageChoose'
import SlidingBlock from './SlidingBlock'
import YesNo from './YesNo'
import Address from './Address'
import Member from './Member'
import Department from './Department'
import Table from "./Table"
import Summary from "./Summary"
import ExternalDataSource from "./ExternalDataSource"
import Phone from "./Phone"
import Location from "./Location"
import OutRequest from "./OutRequest"
import Signature from "./Signature"
import Button from "./Button"
import RelateRecord from "./RelateRecord"
import RealTimeData from "./RealTimeData"
import CurrentViewUser from "./CurrentViewUser"
import Cascade from "./Cascade";
import Qrcode from "./Qrcode";
import Video from "./Video";
import Iframe from "./Iframe";
import LarkApproval from "./LarkApproval";
import ThirdDataTable from "./ThirdDataTable";
import ThirdMap from "./ThirdMap";
import LinkQuery from "./LinkQuery";


export default {
  ['control_' + FORM_ITEM__SINGLE_LINE]: SingleLine,
  ['control_' + FORM_ITEM__MULTILINE]: Multiline,
  ['control_' + FORM_ITEM__NUMBER]: Digital,
  ['control_' + FORM_ITEM__CURRENCY]: Currency,
  ['control_' + FORM_ITEM__SERIAL_NUMBER]: SerialNumber,
  ['control_' + FORM_ITEM__DESCRIPTION]: Description,
  ['control_' + FORM_ITEM__DIVIDINGLINE]: DividingLine,
  ['control_' + FORM_ITEM__SINGLE_CHOOSE]: SingleChoose,
  ['control_' + FORM_ITEM__CHECKBOX]: Checkbox,
  ['control_' + FORM_ITEM__DROPDOWN]: Dropdown,
  ['control_' + FORM_ITEM__RTF]: Rtf,
  ['control_' + FORM_ITEM__DATE]: DateInput,
  ['control_' + FORM_ITEM__DATE_RANGE]: DateRange,
  ['control_' + FORM_ITEM__IMAGE]: ImageAttachment,
  ['control_' + FORM_ITEM__ATTACHMENT]: Attachment,
  ['control_' + FORM_ITEM__GRADE]: Grade,
  ['control_' + FORM_ITEM__IMAGE_CHOOSE]: ImageChoose,
  ['control_' + FORM_ITEM__SLIDING_BLOCK]: SlidingBlock,
  ['control_' + FORM_ITEM__YES_NO]: YesNo,
  ['control_' + FORM_ITEM__ADDRESS]: Address,
  ['control_' + FORM_ITEM__MEMBER]: Member,
  ['control_' + FORM_ITEM__DEPARTMENT]: Department,
  ['control_' + FORM_ITEM__TABLE]: Table,
  ['control_' + FORM_ITEM__SUMMARY]: Summary,
  ['control_' + FORM_ITEM__EXTERNAL_DATA_SOURCE]: ExternalDataSource,
  ['control_' + FORM_ITEM__PHONE]: Phone,
  ['control_' + FORM_ITEM__LOCATION]: Location,
  ['control_' + FORM_ITEM__OUT_REQUEST]: OutRequest,
  ['control_' + FORM_ITEM__SIGNATURE]: Signature,
  ['control_' + FORM_ITEM__BUTTON]: Button,
  ['control_' + FORM_ITEM__RELATE_RECORD]: RelateRecord,
  ['control_' + FORM_ITEM__REALTIME_DATA]: RealTimeData,
  ['control_' + FORM_ITEM__CURRENT_VIEW_USER]: CurrentViewUser,
  ['control_' + FORM_ITEM__CASCADE]: Cascade,
  ['control_' + FORM_ITEM__IFRAME]: Iframe,
  ['control_' + FORM_ITEM__VIDEO]: Video,
  ['control_' + FORM_ITEM__QRCODE]: Qrcode,
  ['control_' + FORM_ITEM__LARK_APPROVAL]: LarkApproval,
  ['control_' + FORM_ITEM__THIRD_DATA_TABLE]: ThirdDataTable,
  ['control_' + FORM_ITEM__THIRD_MAP]: ThirdMap,
  ['control_' + FORM_ITEM__LINK_QUERY]: LinkQuery,

}
